export default __webpack_public_path__ + "static/media/Bradley.2e0818c4.ttf";